module.exports = __webpack_public_path__ + "static/media/04.bb5f95cc.jpg";